import { Directive, inject, input, TemplateRef } from '@angular/core';

/**
 * The cell of one column, written by the page and handed one row at a time.
 *
 * ```html
 * <ng-template mibCell="operator" let-c>{{ c.operator }}</ng-template>
 * ```
 *
 * The value of `mibCell` is the `key` of the column it fills. A column without one shows `row[key]`
 * as text, so a template is only written where a cell is more than a word.
 */
@Directive({ selector: 'ng-template[mibCell]' })
export class MibTableCellDirective<T = unknown> {
  /** The `key` of the column this template fills. */
  readonly column = input.required<string>({ alias: 'mibCell' });
  /** The template written by the page, drawn in every cell of that column. */
  readonly template = inject<TemplateRef<{ $implicit: T }>>(TemplateRef);
}
